import { c } from '../../utils/tailwind-merge';
import { Button } from '../Button/Button';
import { LinkButton } from '../Link/LinkButton';
import { Modal } from '../Modal/Modal';
import { useModal } from '../Modal/useModal';
import { RichText } from '../RichText/RichText';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableRow,
} from '../Table/Table';
import { LicensingTableProps } from './types';

export const LicensingTable = ({
  licenseAgreement,
  licenseType,
  microcopy,
  className = '',
}: LicensingTableProps) => {
  const [isActive, toggle] = useModal();

  const richTextLinkStyles = c(
    'tiny-text break-normal text-right text-blue',
    '[&_a]:tiny-text-link [&_a]:text-blue [&_a]:no-underline [&_a:visited]:tiny-text-link',
    '[&_div]:tiny-text-link [&_div]:text-blue [&_div]:no-underline [&_div:visited]:tiny-text-link'
  );

  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>
      <TableBody>
        <TableRow>
          <TableCell>{licenseAgreement}</TableCell>
          <TableCell className="[&_a]:no-underline [&_span]:no-underline">
            <RichText
              className={richTextLinkStyles}
              html={microcopy.licenseAgreement}
            />
            <div>
              <Modal
                title={microcopy.extensionAssetTitle}
                closeLabel={microcopy.extensionAssetClose}
                isActive={isActive}
                closeModal={toggle}
                portalDomNode={document.getElementById('root')}
                titleClassName={c('!mx-11')}
                actions={
                  <div className="flex gap-2">
                    <Button
                      label={microcopy.extensionAssetClose}
                      onClick={toggle}
                      style="secondary"
                    />
                  </div>
                }
                actionsSide="right"
              >
                <RichText
                  html={microcopy.extensionAssetDescription}
                  className={c(richTextLinkStyles, 'mx-11 text-left')}
                />
              </Modal>
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{licenseType}</TableCell>
          <TableCell
            className={c(
              'break-normal [&_a]:no-underline [&_span]:no-underline',
              className
            )}
          >
            <LinkButton
              className={c(
                'text-balance font-normal capitalize text-blue',
                className
              )}
              onClick={(e) => {
                e?.preventDefault();
                toggle();
              }}
              aria-expanded={isActive}
              label={microcopy.licenseType}
              href={'#'}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
